// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23uxJ","type":"styles_type__1_7lu","choices":"styles_choices__32kYN"};